module.exports = __webpack_public_path__ + "img/vue2-semelle_blanc.3cb0de83.png";